module.exports = __webpack_public_path__ + "media/sos-naufrage.da900dd9.wav";